//-------------------------------------------------------------------------------------------------- Imports
import { Carousel } from "antd";
import { StyleSheet } from "../../StyleSheet";
import { useState, useEffect, useCallback } from "react";
import { useSelector } from "react-redux";
import { getGeneralData } from "../../stores/slices/generalDataSlice";
import { getBannersImages } from "../../methods/Methods";
import { Banners } from "../../types/common";
import InfoCardComponent from "../../components/InfoCardComponent";
import Loading from "../../components/Loading";
import SubDefaultLayout from "../../components/SubDefaultLayout";
import { useNavigate } from "react-router";
import _ from "lodash";

//-------------------------------------------------------------------------------------------------- View
const Promotions = () => {
    const generalData = useSelector(getGeneralData);
    const [idCliente, setIdCliente] = useState<string>("");
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const [bannersPromoImg, setBannersPromoImg] = useState<Array<Banners>>([]);
    const [message, setMessage] = useState("");
    const [hasError, setHasError] = useState(false);
    const navigate = useNavigate();

    const validRoutes = [
        { name: "Menu", path: "/" },
        { name: "MyId", path: "/my-data" },
        { name: "MyServicesHome", path: "/my-services" },
        { name: "PaymentsHome", path: "/payments" },
        { name: "AccountStatements", path: "/" },
        { name: "AccountStatements", path: "/statement" },
        { name: "HistoryCalls", path: "/calls-history" },
        { name: "MessagesList", path: "/notifications" },
        { name: "MobileTelephony", path: "/mobile-telephony" },
        { name: "SettingsHome", path: "/settings" },
        { name: "SettingsBillingData", path: "/my-data/billing-data" },
        { name: "TvSupportHome", path: "/technical-support" },
        { name: "TvSupportAvailableChannels", path: "/technical-support/channel-list" },
        { name: "FrecuentlyQuestions", path: "/technical-support/frequently-question" },
        { name: "InternetSupport", path: "/technical-support/frequently-question" },
        { name: "FrecuentlyQuestionsInternet", path: "/technical-support/frequently-question" },
        { name: "PhoneSupportHome", path: "/technical-support/frequently-question" },
        { name: "FrecuentlyQuestionsFixedPhone", path: "/technical-support/frequently-question" },
        { name: "MovilSupportHome", path: "/technical-support/frequently-question" },
        { name: "FrequentlyQuestionsMobilePhone", path: "/technical-support/frequently-question" },
        { name: "ReferredHome", path: "/referral-system" },
        { name: "PromotionsHome", path: "/promotions" },
        { name: "FrecuentlyQuestionsHome", path: "/technical-support/frequently-question" },
        { name: "DiagnosticHome", path: "/technical-support/technical-diagnostics" },
    ];

    const getBannersPromotionFnt = useCallback(async () => {
        setIsLoading(true);
        await getBannersImages(idCliente, "PROMOTION")
            .then((response) => {
                if (response.data && response.data.data) {
                    setBannersPromoImg(response.data.data);
                } else {
                    setHasError(true);
                    setMessage("No hay promociones disponibles");
                }
                setIsLoading(false);
            })
            .catch(() => {
                setIsLoading(false);
                setHasError(true);
                setMessage("Hubo un error al procesar su solicitud. \nIntente más tarde.");
            })
    }, [idCliente]);

    useEffect(() => {
        if (generalData.selectedContract !== null) {
            setIdCliente(
                generalData.selectedContract.sucursal + generalData.selectedContract.suscriptor
            );
        }
    }, [generalData.selectedContract]);

    useEffect(() => {
        if (!_.isEmpty(idCliente)) {
            getBannersPromotionFnt();
        }
    }, [idCliente, getBannersPromotionFnt])

    return (
        <>
            {
                isLoading ?
                    <Loading />
                    :
                    <SubDefaultLayout title={"Promociones"}>
                        <div style={{ marginTop: 20, marginBottom: 20 }}>
                            {
                                hasError ?
                                    <InfoCardComponent title="¡Estimado usuario!" description={message} />
                                    :
                                    <Carousel
                                        autoplay={true}
                                        style={styles.slideshowContainer}
                                    >
                                        {
                                            bannersPromoImg.map((image, key) => (
                                                image.isPath ?
                                                    (
                                                        <div key={key}>
                                                            {validRoutes.some(route => route.name === image.path) ? (
                                                                <div onClick={() => {
                                                                    const matchedRoute = validRoutes.find(route => route.name === image.path);
                                                                    if (matchedRoute) {
                                                                        navigate(matchedRoute.path);
                                                                    }
                                                                }}>
                                                                    <img src={image.imgUrl} alt={"imagePromotion"} style={{ ...styles.image, cursor: "pointer" }} />
                                                                </div>
                                                            ) : (
                                                                <img src={image.imgUrl} alt={"imagePromotion"} style={{ ...styles.image }} />
                                                            )}

                                                        </div>
                                                    )
                                                    : image.path ?
                                                        <a key={key} href={image.path} target="_blank" rel="noopener noreferrer">
                                                            <img src={image.imgUrl} alt={"imagePromotion"} style={{ ...styles.image, cursor: "pointer" }} />
                                                        </a>
                                                        :
                                                        <div key={key}>
                                                            <img
                                                                src={image.imgUrl}
                                                                style={styles.image}
                                                                alt={"imagePromotion"}
                                                            />
                                                        </div>
                                            ))
                                        }
                                    </Carousel>
                            }
                        </div>
                    </SubDefaultLayout>
            }
        </>
    );
};



//-------------------------------------------------------------------------------------------------- Styles
const styles = StyleSheet.create({
    slideshowContainer: {
        width: "60%",
        overflow: "hidden",
        borderRadius: 25,
        left: "25%",
    },
    image: {
        width: '100%',
        color: "black",
        borderRadius: 25,
    },
});

//-------------------------------------------------------------------------------------------------- Exports
export default Promotions;
